import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  withCredentials: true,
  timeout: 30000,
});

// iter168 — Notification system audit fix.
//
// CARTAL's FastAPI backend raises errors as
//   HTTPException(status, {"ar": "...", "en": "..."})
// so `error.response.data.detail` is very often an OBJECT, not a string.
// A large number of pages do `toast.error(err.response.data.detail)`
// directly, which used to render "[object Object]" (or blank) in the
// toast on production. This helper + interceptor form the single source
// of truth for turning any backend error shape into a localized string.

function _preferredLang() {
  try {
    // Prefer the html lang attribute set by the i18n provider.
    const l = document.documentElement.getAttribute("lang");
    return (l || "ar").toLowerCase().startsWith("en") ? "en" : "ar";
  } catch (_e) { return "ar"; }
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;

  // Bilingual dict shape: {ar: "...", en: "..."}  (main CARTAL pattern)
  if (detail && (typeof detail.ar === "string" || typeof detail.en === "string")) {
    const lang = _preferredLang();
    return detail[lang] || detail.ar || detail.en || "";
  }

  if (Array.isArray(detail))
    return detail
      .map((e) => {
        if (!e) return "";
        if (typeof e === "string") return e;
        if (typeof e.msg === "string") return e.msg;
        if (typeof e.ar === "string" || typeof e.en === "string") return formatApiError(e);
        try { return JSON.stringify(e); } catch { return ""; }
      })
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Response interceptor — flattens `error.response.data.detail` from any
// object shape to a properly localized string BEFORE it reaches the
// component's catch block. This means every existing `toast.error(err
// .response.data.detail)` call across the app now shows a real message
// instead of "[object Object]".
apiClient.interceptors.response.use(
  (r) => r,
  (error) => {
    try {
      const d = error?.response?.data?.detail;
      if (d && typeof d === "object") {
        error.response.data.detail = formatApiError(d);
      }
    } catch (_e) { /* never mask the original error */ }
    return Promise.reject(error);
  },
);

export function formatSAR(n) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(n);
}
